import { moduleForResourceKey, moduleForRoleName, moduleForSidebarKey, ProductModuleId } from './registry'

/** Hospital-pharmacy features that standalone community SKU does not license. */
const HOSPITAL_PHARMACY_SIDEBAR_KEYS = new Set(['med order'])

const asKeyList = (permissionKey: string | string[] | undefined): string[] => {
  if (!permissionKey) return []
  return (Array.isArray(permissionKey) ? permissionKey : [permissionKey]).map(k => k.toString())
}

const stripHospitalPharmacyKeys = (keys: string[], productSku?: string): string[] => {
  if (productSku !== 'pharmacy_only') return keys
  return keys.filter(k => !HOSPITAL_PHARMACY_SIDEBAR_KEYS.has(k.toLowerCase()))
}

/** Whether a sidebar/route permission key is allowed under enabled product modules. */
export const isPermissionAllowedByModules = (
  permissionKey: string | string[] | undefined,
  enabledModules: ProductModuleId[],
  isSuperAdmin: boolean,
  productSku?: string
): boolean => {
  const keys = asKeyList(permissionKey)
  const licensedKeys = stripHospitalPharmacyKeys(keys, productSku)
  if (keys.length > 0 && licensedKeys.length === 0) return false

  if (isSuperAdmin) return true
  if (!licensedKeys.length) return true
  const mod = moduleForSidebarKey(licensedKeys)
  if (!mod) return true
  return enabledModules.includes(mod)
}

/** Whether a role resource permission key is allowed under enabled product modules. */
export const isResourceAllowedByModules = (
  resourceKey: string | undefined,
  enabledModules: ProductModuleId[]
): boolean => {
  if (!resourceKey) return true
  const mod = moduleForResourceKey(resourceKey)
  if (!mod) return true
  return enabledModules.includes(mod)
}

/** Whether a seeded/default role should appear under enabled product modules. Unknown roles stay visible. */
export const isRoleAllowedByModules = (roleName: string | undefined, enabledModules: ProductModuleId[]): boolean => {
  const mod = moduleForRoleName(roleName)
  if (!mod) return true
  return enabledModules.includes(mod)
}
